import { deleteInventoryTransaction } from "../../api/inventoryService";

export const useDeleteInventoryTransaction = (successCallback) => {
    const remove = async (id) => {
        try {
            await deleteInventoryTransaction(id);
            successCallback();
        } catch (error) {
            console.error("Failed to delete inventory transaction:", error);
            throw error;
        }
    };

    return { remove };
};